import {
    USER_GEOLOCATION,
    SET_STORES_OPENINGS_DATES,
    SET_FILTER_STORE,
    SET_DAY,
    SET_STORES,
    SET_INDEX,
    SET_FILTER_STRING,
    BOOKING_ERROR
} from '../Actions/Booking.action';
import {error as errorReducer} from "./Error.reducer";

const defaultState = {
    coords: { lat: 59.91273, lng: 10.74609 },
    stores: [],
    selectedStore: undefined,
    isStoreApproved: false,
    index: undefined,
    filterString: null,
    filteredStores: [],
    day: null,
    opening: [],
    dates: [],
    errorObject: {},
    hideFirstAvailableOptician:false
}

export const booking = (state = defaultState, action) => {
    const { type, payload } = action
    switch (type) {
        case SET_STORES:
        case SET_INDEX:
        case SET_FILTER_STRING:
        case SET_FILTER_STORE:
        case SET_STORES_OPENINGS_DATES:
        case SET_DAY:
        case USER_GEOLOCATION: {
            return ({ ...state, errorObject: {}, ...payload })
        }
        case BOOKING_ERROR:
            return {
                ...state,
                errorObject: errorReducer(state.errorObject, action)
            }
        default:
            return state;
    }
}